//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscIdea(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 4C15.866 4 19 7.13401 19 11C19 13.3783 17.8131 15.4777 16 16.7422V22H8V20H14V15.583C15.7657 14.8114 17 13.0502 17 11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11C7 13.0502 8.23428 14.8114 10 15.583V18H8V16.7422C6.18693 15.4777 5 13.3783 5 11C5 7.13401 8.13401 4 12 4Z" fill="88827E" /><path d="M4 12H2V10H4V12Z" fill="88827E" /><path d="M22 12H20V10H22V12Z" fill="88827E" /><path d="M19.8281 4.41406L18.4141 5.82812L17 4.41406L18.4141 3L19.8281 4.41406Z" fill="88827E" /><path d="M6.82324 4.40918L5.40918 5.82324L3.99414 4.40918L5.40918 2.99414L6.82324 4.40918Z" fill="88827E" /><path d="M13 3H11V1H13V3Z" fill="currentColor" /></svg>;
}
export default IconMiscIdea;